import { orderByDate, orderByValue } from "./sortGrid";

export const columns = {
	cadastros: {
		clientes: [
			{
				text: 'ID',
				align: 'start',
				sortable: true,
				value: 'CODIGOCLIENTE',
			},
			{
				text: 'Razão Social',
				sortable: true,
				value: 'NOMEFANTASIACLIENTE',
			},
			{
				text: 'Cidade',
				sortable: true,
				value: 'CIDADE',
			},
			{
				text: 'Status',
				sortable: true,
				value: 'CODIGO_STATUS',
			},
			{
				text: 'Ações',
				value: 'actions',
				sortable: false,
				width: '100px'
			}
		],
		carros: [
			{
				text: 'ID',
				align: 'start',
				sortable: true,
				value: 'CODIGOCARRO',
			},
			{
				text: 'Placa Carro',
				sortable: true,
				value: 'PLACACARRO',
			},
			{
				text: 'Carro',
				sortable: true,
				value: 'DESCRICAOCARRO',
			},
			{
				text: 'Num. Carro',
				sortable: true,
				value: 'NUMEROCARRO',
			},
			{
				text: 'Status',
				sortable: true,
				value: 'CODIGO_STATUS',
			},
			{
				text: 'Ações',
				value: 'actions',
				sortable: false,
				width: '100px'
			}
		],
		atividades: [
			{
				text: 'ID',
				align: 'start',
				sortable: true,
				value: 'CODTAREFAEXTERNO',
			},
			{
				text: 'Descrição',
				sortable: true,
				value: 'DESCTAREFAEXTERNO',
			},
			{
				text: 'Envolve Região',
				sortable: true,
				value: 'REGIAO',
			},
			{
				text: 'Envolve Carro',
				sortable: true,
				value: 'CARRO',
			},
			{
				text: 'Envolve Cliente',
				sortable: true,
				value: 'CLIENTE',
			},
			{
				text: 'Mostrar na TV',
				sortable: true,
				value: 'MOSTRARTV'
			},
            {
                text: 'Trava Atividade',
                sortable: true,
                value: 'TRAVAATIVIDADE'
            },
            {
                text: 'Trava Usuário',
                sortable: true,
                value: 'TRAVACOLABORADOR'
            },
			{
				text: 'Status',
				sortable: true,
				value: 'CODIGO_STATUS',
			},
			{
				text: 'Ações',
				value: 'actions',
				sortable: false,
				width: '100px'
			}
		],
		regioes: [
			{
				text: 'ID',
				align: 'start',
				sortable: true,
				value: 'ID',
			},
			{
				text: 'Descrição',
				sortable: true,
				value: 'DESCRICAO',
			},
			{
				text: 'Cidades',
				align: 'center',
				sortable: true,
				value: 'CIDADES',
			},
			{
				text: 'Status',
				sortable: true,
				value: 'STATUS',
			},
			{
				text: 'Ações',
				value: 'actions',
				sortable: false,
				width: '100px'
			}
		],
		departamentos: [
			{
				text: 'ID',
				align: 'start',
				sortable: true,
				value: 'ID',
			},
			{
				text: 'Descrição',
				sortable: true,
				value: 'DESCRICAO',
			},
			{
				text: 'Status',
				sortable: true,
				value: 'STATUS',
			},
			{
				text: 'Ações',
				value: 'actions',
				sortable: false,
				width: '100px'
			}
		],
		usuarios: [
			{
				text: 'ID',
				align: 'start',
				sortable: true,
				value: 'ID',
			},
			{
				text: 'Nome',
				sortable: true,
				value: 'NOMECOMPLETOUSUARIO',
			},
			{
				text: 'E-mail',
				sortable: true,
				value: 'EMAILUSER',
			},
			{
				text: 'Departamento',
				sortable: true,
				value: 'DESCRICAOSETOR',
			},
			{
				text: 'Supervisor',
				sortable: false,
				value: 'SUPERVISOR'
			},
			{
				text: 'Status',
				sortable: true,
				value: 'CODIGO_STATUS',
			},
			{
				text: 'Ações',
				value: 'actions',
				sortable: false,
				width: '100px'
			}
		],
		tiposControleFinanceiro: [
			{
				text: 'id',
				align: 'start',
				sortable: true,
				value: 'id',
			},
			{
				text: 'Descrição',
				sortable: true,
				value: 'descricao',
			},
			{
				text: 'Obriga Cidade',
				sortable: true,
				value: 'obrigaCidade',
			},
			{
				text: 'Status',
				sortable: true,
				value: 'idStatus',
			},
			{
				text: 'Ações',
				value: 'actions',
				sortable: false,
				width: '100px'
			}
		],
        carrosManutencaoTipo:[
            {
                text: 'ID',
                align: 'start',
                sortable: true,
                value: 'id'
            },
            {
                text: 'Descrição',
                sortable: true,
                value: 'descricao'
            },
            {
                text: 'Obriga Km Atual',
                sortable: true,
                value: 'obrigaKmAtual'
            },
            {
                text: 'Obriga Próx Serviço',
                sortable: true,
                value: 'obrigaProximoServico'
            },
            {
                text: 'Obriga Solicitação',
                sortable: true,
                value: 'obrigaSolicitacao'
            },
            {
                text: 'Status',
                sortable: true,
                value: 'idStatus'
            },
            {
                text: 'Ações',
                value: 'actions',
                sortable: false,
                width: '100px'
            }
        ]
	},
	lancamentos: {
		agenda: [
			{
				text: 'ID',
				align: 'start',
				sortable: true,
				value: 'ID',
			},
			{
				text: 'Responsável',
				sortable: true,
				value: 'NOMECOMPLETOUSUARIO',
			},
			{
				text: 'Cliente',
				sortable: true,
				value: 'NOMEFANTASIACLIENTE',
			},
			{
				text: 'Deslocamento',
				sortable: true,
				value: 'DESLOC',
			},
			{
				text: 'Atividade',
				sortable: true,
				value: 'DESCTAREFAEXTERNO',
			},
			{
				text: 'Descrição',
				sortable: true,
				value: 'DESCRICAO',
			},
			{
				text: 'Data Inicial',
				sortable: true,
				value: 'DATAINI',
				sort: (a, b) => orderByDate(a, b)
			},
			{
				text: 'Hora Inicial',
				sortable: true,
				value: 'HORAINI',
			},
			{
				text: 'Data Final',
				sortable: true,
				value: 'DATAFIM',
				sort: (a, b) => orderByDate(a, b)
			},
			{
				text: 'Hora Final',
				sortable: true,
				value: 'HORAFIM',
			},
			{
				text: 'Status',
				sortable: true,
				value: 'CODIGO_STATUS',
			},
			{
				text: 'Ações',
				value: 'actions',
				sortable: false,
				width: '100px'
			}
		],
		trackProjetos: [
			{
				text: 'ID',
				align: 'start',
				sortable: true,
				value: 'id',
			},
			{
				text: 'Tipo',
				sortable: true,
				value: 'tipoProjeto',
			},
			{
				text: 'Descrição',
				sortable: true,
				value: 'descricao',
			},
			{
				text: 'Status',
				sortable: true,
				value: 'statusTarefa',
			},
			{
				text: 'Prioridade',
				sortable: true,
				value: 'prioridade',
			},
			{
				text: 'Progresso %',
				sortable: true,
				value: 'progresso',
			},
			{
				text: 'Tarefa',
				sortable: true,
				value: 'idTarefaRedmine',
			},
			{
				text: 'Observação',
				sortable: true,
				value: 'observacao',
			},
			{
				text: 'Data Inicial',
				sortable: true,
				value: 'dataIni',
				sort: (a, b) => orderByDate(a, b)
			},
			{
				text: 'Data Final',
				sortable: true,
				value: 'dataFim',
				sort: (a, b) => orderByDate(a, b)
			},
			{
				text: 'Clientes',
				sortable: true,
				value: 'clientesSolicitantes',
			},
			{
				text: 'Ações',
				value: 'actions',
				sortable: false,
				width: '100px'
			}
		],
		etapasProjeto: [
			{
				text: 'ID',
				align: 'start',
				sortable: true,
				value: 'id',
			},
			{
				text: 'Descrição',
				align: 'start',
				sortable: true,
				value: 'descricao',
			},
			{
				text: 'Responsável',
				align: 'start',
				sortable: true,
				value: 'responsavel',
			},
			{
				text: 'Progresso',
				align: 'start',
				sortable: true,
				value: 'progresso',
			},
			{
				text: 'Observação',
				align: 'start',
				sortable: true,
				value: 'obs',
			},
			{
				text: 'Data Inicial',
				align: 'start',
				sortable: true,
				value: 'dataInicial',
				sort: (a, b) => orderByDate(a, b)
			},
			{
				text: 'Data Final',
				align: 'start',
				sortable: true,
				value: 'dataFinal',
				sort: (a, b) => orderByDate(a, b)
			},
			{
				text: 'Ações',
				sortable: false,
				value: 'actions',
				width: '40px'
			}
		],
		clientesSolicitantesProjeto: [
			{
				text: 'ID',
				align: 'start',
				sortable: true,
				value: 'id',
			},
			{
				text: 'Nome Fantasia',
				align: 'start',
				sortable: true,
				value: 'nomeFantasia',
			},
			{
				text: 'Observação',
				align: 'start',
				sortable: true,
				value: 'observacao',
			},
			{
				text: 'Ações',
				sortable: false,
				value: 'actions',
				width: '40px'
			}
		],
		track: [
			{
				text: "ID",
				align: "start",
				sortable: true,
				value: "ID",
				width: '2%'
			},
			{
				text: "Descrição",
				sortable: true,
				value: "DESCRICAO",
			},
			{
				text: "Atividade",
				sortable: true,
				value: "ACTIVITY",
			},
			{
				text: "Módulo",
				sortable: true,
				value: "MODULE",
			},
			{
				text: "Categoria",
				sortable: true,
				value: "CATEGORY",
			},
			{
				text: "Tag",
				sortable: true,
				value: "TAG",
			},
			{
				text: "Início",
				sortable: true,
				value: "HORAINICIO",
			},
			{
				text: "Fim",
				sortable: true,
				value: "HORAFIM",
			},
			{
				text: "Total",
				sortable: true,
				value: "TOTAL",
			},
			{
				text: "Ações",
				value: "actions",
				sortable: false,
				width: '150px'
			}
		],
		nfseExpress: [
			{
				text: "ID",
				align: "start",
				sortable: true,
				value: "ID_REF_PARCELA_CONTA",
				width: '2%'
			},
			{
				text: "ID Conta",
				sortable: true,
				value: "ID_REF_CONTA",
				cellClass: "descriptionColumn text-truncate",
				align: "start"
			},
			{
				text: "Cliente",
				sortable: true,
				value: "CLIENTE",
				align: "left",
			},
			{
				text: "N. RPS",
				sortable: true,
				value: "NUMERORPS",
				align: "right",
			},
			{
				text: "N. NFS-e",
				sortable: true,
				value: "NUMERONFSE",
				align: "right",
			},
			{
				text: "E-mail",
				sortable: true,
				value: "emailState",
				align: "start",
				width: '150px'
			},
			{
				text: "Serviço",
				sortable: true,
				value: "DISCRIMINACAO",
				align: "start",
				cellClass: "descriptionColumn text-truncate"
			},
			{
				text: "Valor Líquido",
				sortable: true,
				align: "left",
				value: "VALOR_LIQUIDO",
			},
			{
				text: "Ações",
				value: "actions",
				sortable: false
			}
		],
		nfseChecks: [
			{
				text: "ID",
				align: "start",
				sortable: true,
				value: "ID_REF_PARCELA_CONTA",
				width: '2%'
			},
			{
				text: "ID Empresa",
				sortable: true,
				value: "ID_REF_EMPRESA",
				width: '1%',
				align: "start"
			},
			{
				text: "Prestador",
				sortable: true,
				value: "RAZAO_PRESTADOR",
				cellClass: "descriptionColumn text-truncate"
			},
			{
				text: "Tomador",
				sortable: true,
				value: "TOMADOR",
				cellClass: "descriptionColumn text-truncate"
			},
			{
				text: "ID Contas Receber",
				sortable: true,
				value: "ID_REF_CONTA",
				width: '1%'
			},
			{
				text: "Serviço",
				sortable: true,
				value: "DISCRIMINACAO",
				align: "start",
				cellClass: "descriptionColumn text-truncate"
			},
			{
				text: "Valor Bruto",
				sortable: true,
				align: "start",
				value: "VALOR_BRUTO",
			},
			{
				text: "Taxa ISSQN",
				sortable: true,
				align: "end",
				value: "TAXA_ISSQN",
			},
			{
				text: "Valor ISSQN",
				sortable: true,
				align: "start",
				value: "VALOR_ISSQN",
			},
			{
				text: "Valor Líquido",
				sortable: true,
				align: "start",
				value: "VALOR_LIQUIDO",
			},
			{
				text: "Ações",
				value: "actions",
				sortable: false
			}
		],
		cargaDados: [
			{
				text: "ID",
				align: "start",
				sortable: true,
				value: "ID",
				width: '2%'
			},
			{
				text: "Consulta",
				sortable: true,
				value: "consulta"
			},
			{
				text: "Período",
				sortable: true,
				value: "periodo"
			},
			{
				text: "Data Início",
				sortable: true,
				value: "dataInicio",
				sort: (a, b) => orderByDate(a, b)
			},
			{
				text: "Hora Início",
				sortable: true,
				value: "horaInicio",
			},
			{
				text: "Data Fim",
				sortable: true,
				value: "dataFim",
				sort: (a, b) => orderByDate(a, b)
			},
			{
				text: "Hora Fim",
				sortable: true,
				value: "horaFim",
			},
			{
				text: "Tempo decorrido",
				sortable: true,
				value: "tempoExecucao",
			},
			{
				text: "Solicitante",
				sortable: true,
				value: "solicitante",
			},
			{
				text: 'Execução',
				sortable: false,
				value: "LOADING",
				align: 'center'
			},
			{
				text: 'Retornou Dados',
				sortable: false,
				value: "NO_DATA",
				align: 'center'
			}
		],
		controleFinanceiro: [
			{
				text: "ID",
				align: "start",
				sortable: true,
				value: "id",
				width: '2%'
			},
			{
				text: "Responsável",
				sortable: true,
				value: "nomeUsuario"
			},
			{
				text: "Saldo em Dinheiro",
				sortable: true,
				align: "start",
				value: "saldoDinheiro",
				width: '10%'
			},
			{
				text: "Saldo em Cartão",
				sortable: true,
				align: "start",
				value: "saldoCartao",
				width: '10%'
			},
			{
				text: "Status",
				sortable: true,
				align: "start",
				value: "idStatus",
				width: '5%'
			},
			{
				text: "Ações",
				value: "actions",
				sortable: false,
				width: '100px'
			}
		],
		controleServicos: [
			{
				text: "ID",
				align: "start",
				sortable: true,
				value: "id",
				width: '2%'
			},
			{
				text: "Responsável",
				sortable: true,
				value: "colaborador"
			},
			{
				text: "Cliente",
				sortable: true,
				value: "cliente"
			},
			{
				text: "Horas",
				sortable: true,
				align: "start",
				value: "qtdHoras",
				width: '10%'
			},
			{
				text: "Saldo",
				sortable: true,
				align: "start",
				value: "saldoHoras",
				width: '10%'
			},
			{
				text: 'Data Início',
				sortable: true,
				value: 'dataInicio',
				sort: (a, b) => orderByDate(a, b)
			},
			{
				text: 'Status',
				sortable: true,
				value: 'status',
				width: '15%',
				sort: (a, b) => a.descricao.localeCompare(b.descricao)
			},
			{
				text: "Ações",
				value: "actions",
				align: "center",
				sortable: false,
				width: '150px'
			}
        ],
        manutencaoCarros: [
            {
                text: 'Id',
                align: 'start',
                sortable: true,
                value: 'id',
            },
            {
                text: 'Num.',
                sortable: true,
                value: 'numero',
            },
            {
                text: 'Placa',
                sortable: true,
                value: 'placa',
            },
            {
                text: 'Carro',
                sortable: true,
                value: 'carro',
            },
            {
                text: 'Km Atual',
                sortable: true,
                value: 'kmAtual',
            },
            {
                text: 'Próx. Manutenção',
                sortable: false,
                value: 'proximaManutencao',
            },
            {
                text: 'Pend.',
                sortable: false,
                value: 'pendencias',
            },
            {
                text: 'Ações',
                value: 'actions',
                sortable: false,
                width: '100px'
            }
        ],
        solicitacoesManutencao: [
            {
                text: 'Id',
                align: 'start',
                sortable: true,
                value: 'id',
            },
            {
                text: 'Num.',
                sortable: true,
                value: 'numero',
            },
            {
                text: 'Placa',
                sortable: true,
                value: 'placa',
            },
            {
                text: 'Registro',
                sortable: true,
                value: 'dataRegistro',
                sort: (a, b) => orderByDate(a, b)
            },
            {
                text: 'Solicitado por',
                sortable: true,
                value: 'solicitante',
            },
            {
                text: 'Serviço',
                sortable: true,
                value: 'servico',
            },
            {
                text: 'Descrição',
                sortable: true,
                value: 'descricao',
            },
            {
                text: 'Aprov./Recus. por',
                sortable: true,
                value: 'responsavelDecisao',
            },
            {
                text: 'Status',
                sortable: true,
                value: 'status',
            },
            {
                text: 'Ações',
                value: 'actions',
                sortable: false,
                width: '150px'
            }
        ],
	},
	dashboards: {
		saldoBancos: [
			{
				text: 'Código ERP',
				align: 'start',
				sortable: true,
				value: 'codigoCC',
			},
			{
				text: 'Titular',
				sortable: true,
				value: 'titular',
			},
			{
				text: 'Agência / Conta',
				sortable: true,
				value: 'agenciaConta',
			},
			{
				text: 'Saldo Conta',
				sortable: true,
				value: 'saldoCC',
				sort: (a, b) => orderByValue(a, b)
			},
			{
				text: 'Saldo Aplicação',
				sortable: true,
				value: 'saldoAplicacao',
				sort: (a, b) => orderByValue(a, b)
			},
			{
				text: 'Total',
				sortable: true,
				value: 'saldoTotal',
				sort: (a, b) => orderByValue(a, b)
			}
		],
		saldoCaixas: [
			{
				text: 'Código ERP',
				align: 'start',
				sortable: true,
				value: 'codigoCxa',
			},
			{
				text: 'Descrição',
				sortable: true,
				value: 'descricao',
			},
			{
				text: 'Saldo Caixa',
				sortable: true,
				value: 'saldoCxa',
				sort: (a, b) => orderByValue(a, b)
			}
		],
		consultaComissoes: [
			{
				text: 'ID Serviço',
				sortable: true,
				value: 'idLoteServico',
			},
			{
				text: 'Ticket',
				sortable: true,
				value: 'nTicket',
			},
			{
				text: 'Colaborador',
				sortable: true,
				value: 'nomeColaborador',
			},
			{
				text: 'Cliente',
				sortable: true,
				value: 'nomeCliente',
			},
			{
				text: 'Data',
				sortable: true,
				value: 'dataRef',
				isDate: true,
				sort: (a, b) => orderByDate(a, b)
			},
			{
				text: 'Horas',
				sortable: true,
				value: 'horas',
				isHourMin: true,
			},
			{
				text: 'Valor Hora',
				sortable: true,
				value: 'valorHora',
				isCurrency: true,
				sort: (a, b) => orderByValue(a, b)
			},
			{
				text: 'Total',
				sortable: true,
				value: 'total',
				isCurrency: true,
				sort: (a, b) => orderByValue(a, b)
			},
			{
				text: 'Comissão',
				sortable: true,
				value: 'comissao',
				isPercentage: true,
			},
			{
				text: 'A Receber',
				sortable: true,
				value: 'aReceber',
				isCurrency: true,
				sort: (a, b) => orderByValue(a, b)
			},
			{
				text: 'Status',
				sortable: true,
				value: 'status',
			},
			{
				text: 'Referência Pagamento',
				sortable: true,
				align: 'center',
				value: 'dataRefPagamento',
				sort: (a, b) => orderByDate(a, b)
			},
		]
	}
}
